export class ProjectRequest {
    constructor(public parentProject: string, public projectName: string) {

    }
}


/** WEBPACK FOOTER **
 ** ./app/main/FineGrainedAuthorization/project-request.ts
 **/